import { render, staticRenderFns } from "./ScheduleTeam.vue?vue&type=template&id=525a5354&scoped=true"
import script from "./ScheduleTeam.vue?vue&type=script&lang=js"
export * from "./ScheduleTeam.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTeam.vue?vue&type=style&index=0&id=525a5354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a5354",
  null
  
)

export default component.exports